/** author: 胡枭 */

import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_COMPANY_API

// 退出登录
export function logoutApi() {
  return request({
    url: baseUrl + '/logout',
    method: 'post'
  })
}

// 用户登录状态验证
export function checkApi() {
  return request({
    url: baseUrl + '/passport/status',
    method: 'get'
  })
}

// 获取用户信息
export function getUserInfoApi() {
  return request({
    url: baseUrl + '/users/oneself',
    method: 'get'
  })
}

// 获取员工信息
export function getEmployeeInfoApi(needLoading = true) {
  return request(
    {
      url: baseUrl + '/enterprise/employees/oneself',
      method: 'get'
    },
    needLoading
  )
}

// 获取员工的监管信息 （拥有查询统计权限的员工使用）
export function getEmployeeSuperviseApi() {
  return request({
    url: `${baseUrl}/enterprise/employees/oneself/supervise-info`,
    method: 'get'
  })
}

// 查询手机号是否被注册
export function searchIfMobileOccupiedApi(params) {
  return request({
    url: baseUrl + '/users/mobile/exist',
    method: 'get',
    params
  })
}

// 图形验证码
export function getCaptchaApi() {
  return request({
    url: baseUrl + '/captcha',
    method: 'get'
  })
}

// 修改密码 (使用原密码修改)
export function editPasswordApi(data) {
  return request({
    url: baseUrl + '/users/oneself/password',
    method: 'patch',
    data
  })
}

// 请求手机验证码
export function getVerifyCodeApi(data) {
  return request({
    url: baseUrl + '/passport/sms/send',
    method: 'post',
    data
  })
}

// 获取已加入企业
export function getJoinCompanyApi() {
  return request(
    {
      url: baseUrl + '/users/oneself/join-company',
      method: 'get'
    },
    false
  )
}

// 选择企业进入公司
export function enterCompanyApi(data) {
  return request(
    {
      url: baseUrl + '/users/oneself/enter-company',
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data
    },
    true
  )
}

// 获取绑定微信二维码
export function getBindWechatQrCodeApi(needLoading = false) {
  return request(
    {
      url: `${baseUrl}/users/oneself/wx/mp/bind/qr-code`,
      method: 'get'
    },
    needLoading
  )
}

// 生成访问凭证
export function getAccessTokenApi() {
  return request({
    url: baseUrl + '/users/oneself/access-token',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

